import { useDispatch, useSelector } from 'react-redux';
import type { DateValue } from 'react-aria';
import { parseDateTime, today, getLocalTimeZone } from '@internationalized/date';
import { selectSurgeryDate, selectShowInvalids } from '@store/order/selectors';
import { setSurgeryDate } from '@store/order/slice';
import Calendar from '@components/calendar/Calendar';
import { invalidFormValue } from '@components/utils';



const SurgeryDate = (): JSX.Element => {

	const surgeryDate = useSelector(selectSurgeryDate);
	const showInvalids = useSelector(selectShowInvalids);

	const dispatch = useDispatch();
	const updateSurgeryDate = (value: string | null) => dispatch(setSurgeryDate(value));

	return (
		<div className='surgery-date'>

			<label className='surgery-label'>
				Termín zákroku / kdy límec potřebuji <span>*</span> {showInvalids && invalidFormValue(surgeryDate) &&
					<p className='form-invalid'>Povinné pole</p>}
			</label>

			<div className='surgery-calendar'>
				<Calendar
					aria-label="Date (controlled)"
					value={surgeryDate ? parseDateTime(surgeryDate) : null}
					minValue={today(getLocalTimeZone())}
					onChange={(e: DateValue) => updateSurgeryDate(e.toString())} />
			</div>

			<p><span>* Potřebujete límec okamžitě?</span> Nebojte, na urgentní zakázky jsme zvyklí. Vyznačte datum, včetně dnešního dne, a my se Vám ozveme zpět.</p>

		</div>
	);
};

export default SurgeryDate;